import { microFrontListener } from '@b2ag/micro-front-tools'
import { useAnalyticService } from '@b2ag/plugin-aladin-gtm'
import { isWebViewFarmi } from '@b2ag/farmi-app-appro-tools'
import { isFarmi } from '@b2ag/app-brands'

import { PAGE_TYPE } from '../page-types'

const VHome = () => import('@b2ag/marketing/src/application/views/VHome/VHome.vue')

/* ------- MICROFRONT - PORTAL ------- */

export const portalRoutes = [
  {
    path: '/',
    name: 'portal-home',
    component: () => import('@b2ag/micro-front-portal/app'),
    props: () => ({
      microFrontName: 'portal',
      viewName: 'home',
    }),
    beforeEnter() {
      microFrontListener({
        iframe: { href: window.location.origin },
        analyticService: useAnalyticService(),
      })
    },
    meta: {
      hideHeaderMenu: true,
    },
  },
  {
    path: '/collect',
    name: 'portal-collect',
    component: () => import('@b2ag/micro-front-portal/app'),
    props: () => ({
      microFrontName: 'portal',
      viewName: 'collect',
    }),
    beforeEnter() {
      microFrontListener({
        iframe: { href: window.location.origin },
        analyticService: useAnalyticService(),
      })
    },
    meta: {
      hideHeaderMenu: true,
    },
  },
  {
    path: '/agro-pilot',
    name: 'portal-agro-pilot',
    component: () => import('@b2ag/micro-front-portal/app'),
    props: () => ({
      microFrontName: 'portal',
      viewName: 'agro-pilot',
    }),
    beforeEnter() {
      microFrontListener({
        iframe: { href: window.location.origin },
        analyticService: useAnalyticService(),
      })
    },
    meta: {
      hideHeaderMenu: true,
    },
  },
  {
    path: '/cp/:page',
    name: 'portal-contentful-page',
    component: () => import('@b2ag/micro-front-portal/app'),
    props: (route) => ({
      microFrontName: 'portal',
      viewName: route.params.page,
    }),
    beforeEnter() {
      microFrontListener({
        iframe: { href: window.location.origin },
        analyticService: useAnalyticService(),
      })
    },
    meta: {
      hideHeaderMenu: true,
    },
  },
  {
    path: '/shop',
    name: 'portal-shop',
    component: VHome,
    beforeEnter(_, __, next) {
      if (isFarmi && isWebViewFarmi()) {
        next({ name: 'farmi-app-appro-categories' })
      } else {
        next()
      }
    },
    meta: {
      analyticsPageType: PAGE_TYPE.HOME,
    },
  },
]
